module.exports = __webpack_public_path__ + "img/pg-inisis-promotion.2c790aea.png";